import { Subject } from 'rxjs';

import { Input, Component, OnDestroy } from '@angular/core';

@Component({
  selector: 'sn-whooster-address-details',
  templateUrl: './whooster-address-details.component.html',
  styleUrls: ['./whooster-address-details.component.scss'],
})
export class FsWhoosterAddressDetailsComponent implements OnDestroy {
  @Input() public readonly data;

  private readonly _destroy$ = new Subject<void>();

  constructor() {}

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public moreDetails(): boolean {
    return (
      this.data?.name?.length > 1 ||
      this.data?.phone?.length > 1 ||
      this.data?.email?.length > 1 ||
      this.data?.relatives?.length > 1
    );
  }
}
